import { OpenAPI, Profile, ProfileService } from '@/api/';
import { User } from 'firebase/auth';
import { action, atom } from 'nanostores';

let tokenRefreshInterval: number = 0;

/**
 * The current user from Firestore auth.
 */
export const $user = atom<User | undefined>();

/**
 * The current profile from the backend.
 */
export const $profile = atom<Profile | undefined>();

// Loader for login state
export const $profileLoader = atom<boolean>(true);

// State for controlling the global sidebar
export const $sideBarCollapsed = atom<boolean>(
  localStorage.getItem('sideBarCollapsed') === 'true'
);

// Subscribe to changes and update localStorage
$sideBarCollapsed.subscribe((value) => {
  localStorage.setItem('sideBarCollapsed', value.toString());
});

/**
 * Sets the current user which will also update the
 * OpenAPI token to the backend.
 */
export const setUser = action(
  $profile,
  'setUser',
  async (store, authUser: User) => {
    console.log(` ⚡︎ Setting user: ${authUser.email}`);

    $user.set(authUser);

    // Get the profile by the email of the authenticated user.
    try {
      OpenAPI.TOKEN = await authUser.getIdToken();

      // The user token is included in this call and the server will extract the
      // auth ID from the token directly.
      const result = await ProfileService.getProfile();

      await signalRService.connect(OpenAPI.TOKEN);

      $profile.set(result.profile);
      $profileLoader.set(false);

      window.clearInterval(tokenRefreshInterval);

      // Interval for refreshing the token.
      tokenRefreshInterval = window.setInterval(
        async () => {
          OpenAPI.TOKEN = await $user.get()?.getIdToken(true);
        },
        120 * 60 * 1000,
      ); // Refresh every 120 minutes
    } catch (error) {
      console.error('Error retrieving profile');
      console.error(error);

      clearUser();

      if (!window.location.href.includes('login')) {
        window.location.replace('/login');
      }
    }
  },
);

/**
 * Clears the user state by resetting everything to null.
 */
export const clearUser = action($profile, 'clearUser', store => {
  $profile.set(undefined);
  $user.set(undefined);
  $org.set(undefined);
});
